import styled, { createGlobalStyle } from 'styled-components';

// eslint-disable-next-line import/no-unresolved
import BaseInnerImageZoom from 'vendor/react-inner-image-zoom';

// Add global styles for the portal
const ZoomableImagePortalStyles = createGlobalStyle`
  .iiz__zoom-portal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;
  }
`;

const ZoomableImage = styled(BaseInnerImageZoom)`
  &.iiz {
    max-width: 100%;
    margin: 0;
    position: relative;
    overflow: hidden;
    display: inline-block;
    cursor: zoom-in;
  }

  .iiz--drag .iiz__zoom-img--visible {
    cursor: grab;
  }

  .iiz__img {
    max-width: 100%;
    height: auto;
    display: block;
    pointer-events: none;
    visibility: visible;
    opacity: 1;
  }

  .iiz__img--hidden {
    visibility: hidden;
    opacity: 0;
  }

  .iiz__img--abs {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
  }

  .iiz__zoom-img {
    width: auto !important;
    max-width: none !important;
    position: absolute;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    display: block;
  }

  .iiz__zoom-img--visible {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
    cursor: zoom-out;
    touch-action: none;
  }

  .iiz__btn {
    background: rgba(255, 255, 255, 0.8);
    width: 40px;
    height: 40px;
    border: none;
    outline: none;
    padding: 0;
    position: absolute;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    appearance: none;
  }

  .iiz__btn:before {
    content: ' ';
    background-position: center;
    background-repeat: no-repeat;
    display: block;
  }

  .iiz__hint {
    bottom: 10px;
    right: 10px;
    pointer-events: none;
  }

  .iiz__hint:before {
    content: ' ';
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.69362 16.4551L7.06783 15.5278L7.06782 15.5278L6.69362 16.4551ZM12.3066 2.54493L11.9324 3.47228L11.9324 3.47228L12.3066 2.54493ZM17.6319 19.046C18.0224 19.4365 18.6555 19.4365 19.0461 19.046C19.4366 18.6554 19.4366 18.0223 19.0461 17.6318L17.6319 19.046ZM6.31942 17.3825C7.35456 17.8002 8.46183 18.0099 9.57802 17.9997L9.5597 15.9998C8.70614 16.0076 7.8594 15.8472 7.06783 15.5278L6.31942 17.3825ZM9.57802 17.9997C10.6942 17.9894 11.7975 17.7595 12.8248 17.3229L12.0425 15.4822C11.2569 15.8161 10.4133 15.9919 9.5597 15.9998L9.57802 17.9997ZM12.8248 17.3229C13.8521 16.8863 14.7833 16.2516 15.5654 15.4551L14.1383 14.0539C13.5402 14.663 12.8281 15.1483 12.0425 15.4822L12.8248 17.3229ZM15.5654 15.4551C16.3474 14.6586 16.9649 13.7159 17.3826 12.6808L15.5279 11.9323C15.2085 12.7239 14.7363 13.4448 14.1383 14.0539L15.5654 15.4551ZM17.3826 12.6808C17.8003 11.6456 18.01 10.5383 17.9998 9.42215L15.9999 9.44048C16.0077 10.294 15.8473 11.1408 15.5279 11.9323L17.3826 12.6808ZM17.9998 9.42215C17.9896 8.30596 17.7596 7.20271 17.323 6.1754L15.4823 6.95767C15.8162 7.74326 15.9921 8.58692 15.9999 9.44048L17.9998 9.42215ZM17.323 6.1754C16.8864 5.14809 16.2517 4.21683 15.4552 3.4348L14.054 4.86192C14.6631 5.45994 15.1484 6.17208 15.4823 6.95767L17.323 6.1754ZM15.4552 3.4348C14.6587 2.65277 13.716 2.03528 12.6808 1.61759L11.9324 3.47228C12.724 3.7917 13.4449 4.2639 14.054 4.86192L15.4552 3.4348ZM12.6809 1.61759C11.6457 1.19989 10.5384 0.990162 9.42225 1.00039L9.44057 3.0003C10.2941 2.99248 11.1409 3.15286 11.9324 3.47228L12.6809 1.61759ZM9.42225 1.00039C8.30606 1.01061 7.20281 1.24059 6.1755 1.67718L6.95776 3.51785C7.74335 3.18399 8.58701 3.00812 9.44057 3.0003L9.42225 1.00039ZM6.1755 1.67718C5.14819 2.11378 4.21693 2.74844 3.4349 3.54494L4.86201 4.94614C5.46003 4.33705 6.17217 3.85172 6.95776 3.51785L6.1755 1.67718ZM3.4349 3.54494C2.65286 4.34144 2.03537 5.28417 1.61767 6.31931L3.47236 7.06771C3.79178 6.27614 4.26398 5.55522 4.86201 4.94614L3.4349 3.54494ZM1.61767 6.31931C1.19997 7.35445 0.99025 8.46172 1.00048 9.57791L3.0004 9.55959C2.99257 8.70603 3.15295 7.85929 3.47236 7.06771L1.61767 6.31931ZM1.00048 9.57791C1.01071 10.6941 1.24069 11.7973 1.67728 12.8247L3.51795 12.0424C3.18408 11.2568 3.00822 10.4131 3.0004 9.55959L1.00048 9.57791ZM1.67728 12.8247C2.11388 13.852 2.74855 14.7832 3.54505 15.5653L4.94624 14.1381C4.33715 13.5401 3.85182 12.828 3.51795 12.0424L1.67728 12.8247ZM3.54505 15.5653C4.34155 16.3473 5.28428 16.9648 6.31942 17.3825L7.06782 15.5278C6.27624 15.2084 5.55533 14.7362 4.94624 14.1381L3.54505 15.5653ZM14.0963 15.5104L17.6319 19.046L19.0461 17.6318L15.5105 14.0962L14.0963 15.5104Z' fill='%23485055'/%3E%3C/svg%3E%0A");
    width: 20px;
    height: 20px;
  }

  .iiz__close {
    top: 10px;
    right: 10px;
    visibility: hidden;
    opacity: 0;
  }

  .iiz__close--visible {
    visibility: visible;
    opacity: 1;
    cursor: pointer;
  }

  .iiz__close::before {
    content: ' ';
    width: 29px;
    height: 29px;
    background-image: linear-gradient(#222, #222), linear-gradient(#222, #222);
    background-size: 100% 1px, 1px 100%;
    transform: rotate(45deg);
  }
`;

// Export both components
export { ZoomableImagePortalStyles };
export default ZoomableImage;
